function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
//Limitless imports
import { DialogueNote } from "../../../../../customer/components";
import TimePosted from "../time-posted/TimePosted";
import { withi18n } from "../../../../../customer/components";
import TranslationText from "../translation-text/TranslationText";
const useStyles = makeStyles(({
  palette
}) => ({
  responseListContainer: {
    display: "flex",
    flex: "1",
    flexDirection: "row"
  },
  responseListItem: {
    display: "flex",
    position: "relative",
    flexDirection: "column",
    backgroundColor: palette.background.default,
    boxShadow: "0px 2px 6px -2px rgba(0, 0, 0, 0.06)",
    borderRadius: "20px",
    background: palette.secondary.contrastText,
    width: "fit-content"
  },
  responseList: {
    padding: 16
  },
  responseListAttachment: {
    background: palette.background.default,
    padding: "24px 32px 24px 32px",
    boxShadow: "0px 2px 6px -2px rgba(0, 0, 0, 0.06)",
    borderRadius: "20px"
  },
  responseTime: {
    display: "flex",
    paddingTop: 8
  },
  dialogueNote: {
    display: "flex",
    width: "8%",
    marginLeft: 5,
    justifyContent: "space-between",
    alignItems: "end",
    position: "relative",
    marginBottom: 28
  },
  responseContainer: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "70%"
  },
  bottomTextContainer: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: 8
  }
}));
const CustomerDialogueWrapper = ({
  children,
  dialogue,
  message,
  dialogueSuffixMap,
  hideTime = false,
  isCustomerAttachment = false,
  ...rest
}) => {
  const classes = useStyles();
  const {
    created,
    contentModerated,
    body
  } = dialogue;
  const hasDialogueNote = contentModerated && contentModerated.reason ? true : false;
  let Suffix;
  if (dialogueSuffixMap) {
    Suffix = dialogueSuffixMap[message.conversationState.type];
  }
  const contentModeratedData = contentModerated !== null && contentModerated !== void 0 && contentModerated.action ? {
    action: contentModerated.action,
    reason: contentModerated.action === "masked" ? "We detected unsuitable language in the customer's response and have changed the message accordingly to protect our community. If you believe this to be an error, please contact the Limitless support team." : contentModerated.reason
  } : contentModerated;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classes.responseListContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.responseContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: `${classes.responseListItem} ${isCustomerAttachment ? classes.responseListAttachment : classes.responseList}`
  }, children), /*#__PURE__*/React.createElement("div", {
    className: classes.bottomTextContainer
  }, !hideTime && /*#__PURE__*/React.createElement(TimePosted, {
    time: created
  }), message.conversationState.isTranslated && typeof body === "string" && /*#__PURE__*/React.createElement(TranslationText, null))), /*#__PURE__*/React.createElement("div", {
    className: classes.dialogueNote
  }, hasDialogueNote && /*#__PURE__*/React.createElement(DialogueNote, {
    position: "bottom-start",
    note: contentModeratedData
  }), Suffix && /*#__PURE__*/React.createElement(Suffix, _extends({
    message: message,
    dialogue: dialogue
  }, rest)))));
};
export default withi18n(CustomerDialogueWrapper);
CustomerDialogueWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  dialogue: PropTypes.object.isRequired,
  dialogueSuffixMap: PropTypes.object,
  message: PropTypes.object.isRequired,
  hideTime: PropTypes.bool,
  isCustomerAttachment: PropTypes.bool,
  t: PropTypes.func.isRequired
};